export enum roles {
    intrastats_guest = "intrastats-guest",
    intrastats_admin = "intrastats-admin",
}